import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
export const CHECKOUT_URL = 'https://latam-acupuntura.impultienda.ar';
export const SUPPORT_EMAIL = 'soportelumenakasha@gmail.com';
export const WHATSAPP_LABEL = '+54 11 5339-9780';
export const WHATSAPP_URL = 'https://wa.me/5491153399780';
export const PRICE = 'USD 17';
export const PRICE_FULL = 'USD 50';
type SectionProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
  glow?: boolean;
};
export function Section({
  children,
  className = '',
  id = '',
  glow = false
}: SectionProps) {
  const reduceMotion = useReducedMotion();
  return <motion.section id={id} initial={reduceMotion ? false : {
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.45,
    ease: [0.22, 1, 0.36, 1]
  }} className={`relative mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 md:py-20 lg:px-8 ${className}`} data-id="element-264" data-mp="kerxpiu2thlk">
      {glow && <div className="absolute inset-x-[12%] top-10 -z-10 h-48 rounded-full bg-brand-goldLight/50 blur-3xl" aria-hidden="true" data-id="element-265" data-mp="34lpmxstk91oz" />}
      {children}
    </motion.section>;
}
type CTAButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'cinnabar' | 'gold';
};
export function CTAButton({
  children,
  href = CHECKOUT_URL,
  className = '',
  fullWidth = false,
  variant = 'cinnabar'
}: CTAButtonProps) {
  const reduceMotion = useReducedMotion();
  const colorClass = variant === 'cinnabar' ? 'cinnabar-bg' : 'gold-bg';
  return <motion.a href={href} whileHover={reduceMotion ? undefined : {
    scale: 1.02,
    y: -1
  }} whileTap={reduceMotion ? undefined : {
    scale: 0.98
  }} transition={{
    duration: 0.16,
    ease: [0.23, 1, 0.32, 1]
  }} className={`cta-shimmer relative inline-flex items-center justify-center rounded-sm px-8 py-4 text-center text-base font-bold tracking-wide text-brand-paper shadow-[0_8px_20px_rgba(122,42,32,0.24)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-ink ${colorClass} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-266" data-mp="27unq7y7h2eu6">
      <span className="relative z-10" data-id="element-267" data-mp="2gwht5v9l9k7y">{children}</span>
    </motion.a>;
}
type SectionHeadingProps = {
  children: React.ReactNode;
  character?: string;
  className?: string;
};
export function SectionHeading({
  children,
  character = '氣',
  className = ''
}: SectionHeadingProps) {
  return <div className={`text-center ${className}`} data-id="element-268" data-mp="2uw99w3rhpepn">
      <p className="font-kanji text-xl text-brand-goldDark/70 md:text-2xl" aria-hidden="true" data-id="element-269" data-mp="2uvhi7410k14n">
        {character}
      </p>
      <h2 className="mt-2 font-serif text-2xl font-bold leading-tight text-brand-ink md:text-4xl" data-id="element-270" data-mp="o80blycn8gk2">
        {children}
      </h2>
      <span className="fret-rule mx-auto mt-4 block w-40 opacity-70 sm:w-56" aria-hidden="true" data-id="element-271" data-mp="j9p1rnmcm61u" />
    </div>;
}